import React, { useState } from "react"
import './lexicon-chimera.css';
import SEO from "../components/seo";

const wordModes = [
  'prefix',
  'suffix',
  'both'
]

function getRandomElement(list){
  return list[Math.floor(Math.random()*list.length)]
}

function createWord(wordPieces) {
  const mode = getRandomElement(wordModes);
  let word = '';
  if(mode === 'prefix' || mode === 'both'){
    word += getRandomElement(wordPieces.prefixes)+'-';
  }
  word += getRandomElement(wordPieces.terms);
  if(mode === 'suffix' || mode === 'both'){
    word += '-'+getRandomElement(wordPieces.suffixes);
  }
  return word;
}

const ChimeraIndexPage = ({ data }) => {
  const { wordPieces, iconRefresh, logo } = data;

  const [state, setState] = useState({
    word: createWord(wordPieces)
  });

  return (
    <div className="Wrapper ChimeraWrapper">
      <SEO title="FUEL4DESIGN: Lexicon Chimera" description="A tool to create new words fostering futures design." />
      <div className="Chimera">
        <header
          className="Chimera__Header"
        >
          <img className="Chimera__Logo" src={logo.publicURL} alt="FUEL4Design" />
          <div className="Chimera__Title">LEXICON <strong>CHIMERA:</strong></div>
        </header>
        <main className="Chimera__Main">
          <div className="Chimera__Desc">A tool to create new words fostering futures design.</div>
          <div className="Chimera__Core">
            <div className="Chimera__Result">{state.word}</div>
            <div className="Chimera__CoreDesc">Define this word and imagine how it plays a role in designing futures.</div>
            <button type="button" className="Chimera__CoreButton button" onClick={() => setState({
              ...state,
              word: createWord(wordPieces)
            })} ><img className="icon" alt="Refresh icon" src={iconRefresh.publicURL} />GENERATE A NEW WORD</button>
          </div>
        </main>
        <footer className="Chimera__Footer">
            <div>Future Education and Literacy for Designers (ERASMUS +)</div>
            <a target="_blank" rel="noopener noreferrer"  href="http://fuel4design.org/index.php/design-futures-lexicon">Go to the Design Futures Lexicon</a>
        </footer>
      </div>
    </div>
  )
}

export default ChimeraIndexPage

export const pageQuery = graphql`
  query ChimeraIndexQuery {
    wordPieces:termsYaml {
      prefixes
      suffixes
      terms
    }
    logo:file(base: {eq: "logo.svg"}) {
      base
      publicURL
    }
    iconRefresh:file(base: {eq: "icon-refresh.svg"}) {
      base
      publicURL
    }
  }
`;

